// src/components/Dashboard/AttentionBoard.jsx
//
// Lo que necesita atención arriba de Reclamos / Comisiones: una fila de
// tarjetas resumidas (icono, nombre, cuántos y una pista) y, al tocar una, su
// lista completa a todo el ancho debajo, una fila por problema. Solo una
// abierta a la vez; tocarla de nuevo (o "Cerrar") la pliega.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './AttentionBoard.css';

// sections: [{ id, icon, label, count, tone: 'danger'|'warning'|'info'|'neutral', hint,
//   items: [{ key, number, title, detail, note, badge, to, state, external, action }] }]
const AttentionBoard = ({ sections, defaultOpen = null, es = true, ariaLabel }) => {
  const visible = sections.filter(section => section.count > 0);
  const [openId, setOpenId] = useState(null);
  const [touched, setTouched] = useState(false);
  const visibleIds = visible.map(section => section.id).join('|');
  useEffect(() => {
    const ids = visibleIds ? visibleIds.split('|') : [];
    // Los datos llegan después del primer render: la sección por defecto se
    // abre en cuanto aparece, mientras la persona no haya tocado nada.
    if (!touched && !openId && defaultOpen && ids.includes(defaultOpen)) setOpenId(defaultOpen);
    // Si la sección abierta se queda vacía (se resolvió), se pliega.
    if (openId && ids.length && !ids.includes(openId)) setOpenId(null);
  }, [visibleIds, defaultOpen, openId, touched]);
  const toggle = id => { setTouched(true); setOpenId(current => (current === id ? null : id)); };
  if (visible.length === 0) return null;
  const open = visible.find(section => section.id === openId);

  return (
    <section className="ab" aria-label={ariaLabel}>
      <div className="ab-tiles">
        {visible.map(section => {
          const isOpen = section.id === openId;
          return (
            <button key={section.id} type="button" className={`ab-tile is-${section.tone || 'neutral'} ${isOpen ? 'is-open' : ''}`}
              aria-expanded={isOpen} aria-controls="ab-panel" onClick={() => toggle(section.id)}>
              <span className="ab-tile-icon" aria-hidden="true"><i className={section.icon} /></span>
              <span className="ab-tile-text">
                <span className="ab-tile-label">{section.label}</span>
                {section.hint && <span className="ab-tile-hint">{section.hint}</span>}
              </span>
              <strong className="ab-tile-count">{section.count}</strong>
              <i className={`fa-solid fa-chevron-${isOpen ? 'up' : 'down'} ab-tile-caret`} aria-hidden="true" />
            </button>
          );
        })}
      </div>

      {open && (
        <div className={`ab-panel is-${open.tone || 'neutral'}`} id="ab-panel">
          <header className="ab-panel-head">
            <h3><i className={open.icon} aria-hidden="true" /> {open.label} <span className="ab-panel-count">{open.count}</span></h3>
            <button type="button" className="ab-close" onClick={() => { setTouched(true); setOpenId(null); }}>
              {es ? 'Cerrar' : 'Close'} <i className="fa-solid fa-xmark" aria-hidden="true" />
            </button>
          </header>
          <ul className="ab-list">
            {open.items.map(item => (
              <li key={item.key} className="ab-row">
                <span className="ab-number">{item.number || '—'}</span>
                <span className="ab-main">
                  <strong>{item.title || 'N/A'}</strong>
                  {item.detail && <span>{item.detail}</span>}
                  {item.note && <span className="ab-note">{item.note}</span>}
                </span>
                <span className="ab-badge">{item.badge}</span>
                {item.to ? (
                  <Link className="ab-action" to={item.to} state={item.state}
                    {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                    {item.action || (es ? 'Abrir' : 'Open')}
                    <i className={`fa-solid ${item.external ? 'fa-arrow-up-right-from-square' : 'fa-arrow-right'}`} aria-hidden="true" />
                  </Link>
                ) : <span />}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};

export default AttentionBoard;
